import React from "react";
import { Dialog, DialogContent, Box, Typography, Button, IconButton, Divider } from "@mui/material";
import { Close, Apple } from "@mui/icons-material";
import { QRCodeSVG } from "qrcode.react";
import { IOS_APP_STORE_URL } from "./AppStoreLink";

// Controlled — `open`/`onClose` come from useIosAppAnnouncement, shared by
// whichever layout renders this (auto-shown once after login on the
// customer portal, or reopened any time via the footer/sidebar "Download
// on the App Store" link).
export default function IosAppAnnouncementDialog({ open, onClose }) {
  const handleViewOnAppStore = () => {
    window.open(IOS_APP_STORE_URL, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{ paper: { sx: { overflow: "hidden" } } }}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #001A3C 0%, #0D629B 100%)",
          pt: 4,
          pb: 6,
          px: 3,
          textAlign: "center",
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", top: 8, right: 8, color: "rgba(255,255,255,0.7)" }}
        >
          <Close fontSize="small" />
        </IconButton>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "20px",
            bgcolor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            boxShadow: "0 12px 28px rgba(0,0,0,0.25)",
          }}
        >
          <Apple sx={{ fontSize: 40, color: "#001A3C" }} />
        </Box>
      </Box>

      <DialogContent sx={{ textAlign: "center", pt: 0, pb: 4, px: 4, mt: -3.5 }}>
        <Box
          sx={{
            bgcolor: "background.paper",
            borderRadius: 3,
            px: 2,
            pt: 3,
            pb: 0.5,
          }}
        >
          <Typography variant="h4" fontWeight={800} sx={{ mb: 2, mt: 3 }}>
            Hey, We're on the App Store! 🎉
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, }}>
            My Waypoint is here for iPhone — a faster way to keep an eye on your shipments than the browser.
          </Typography>

          <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
            SCAN WITH YOUR PHONE
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2.5,
              p: 1.5,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              width: "fit-content",
              mx: "auto",
            }}
          >
            <QRCodeSVG value={IOS_APP_STORE_URL} size={120} level="M" />
          </Box>

          <Divider sx={{ mb: 2.5 }}>
            <Typography variant="caption" color="text.secondary">
              OR
            </Typography>
          </Divider>

          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={handleViewOnAppStore}
            startIcon={<Apple />}
            sx={{ mb: 1, py: 1.375, borderRadius: 2.5, fontWeight: 700 }}
          >
            Get the App
          </Button>
          <Button variant="text" fullWidth onClick={onClose} sx={{ color: "text.secondary" }}>
            Maybe later
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
